
export const fieldValidation = {
    EMIAL: 'email',
    NUMBER: 'number',
    BOOLEAN: 'BOOLEAN',
    PASSWORD: 'password',
    STRING: 'string',
    LIST: 'list',
  };